<template>
  <div>
    <!-- Dco Data section -->
    <section
      class="pdf-item bg-white w-full p-4 border rounded-lg w-full bg-gray-50 mb-4"
      v-for="(item, index) of grouppedData"
      :key="index"
    >
      <AnyChart
        class="justify-self-stretch border rounded-lg mb-4 ..."
        v-for="(chartData, chartIndex) of getChartData(index)"
        :key="chartIndex"
        :title="chartData[0].FormulaData.VarName"
        :reportData="chartData"
        :period="reportData.form.dataForm"
        chartType="bar"
        @rawChart="
          setChartBaseSource(
            $event,
            chartData[0].FormulaData.VarLabel + '-' + index
          )
        "
      />

      <HistoricalReport
        class="mt-2"
        :items="item"
        :title="`${index} Details `"
        :assets-properties="assetsProperties"
        :options="summaryOptions"
        :type="reportData.form.dataForm"
      />
    </section>
    <!-- Dco Data section -->
  </div>
</template>
<script>
import HistoricalReport from '@/components/Reports/HistoricalReport'
import AnyChart from '@/components/Reports/AnyChart'
import { format, date, utc } from '@/helpers/datetime'
import PdfReportTemplate from '@/components/Reports/PdfReport'
import reportContentMixin from '@/mixins/ReportContent'

export default {
  mixins: [reportContentMixin],
  props: {
    reportData: {
      type: Object
    },
    period: {
      type: String
    },
    exportPdf: {
      type: Boolean
    }
  },
  components: {
    HistoricalReport,
    AnyChart
  },
  data() {
    return {
      grouppedAssets: [],
      assets: [],
      grouppedData: {},
      chartImage: [],
      assetsProperties: [],
      summaryOptions: {
        allowToAdd: false,
        allowToRefetch: false,
        allowExporting: false
      }
    }
  },
  watch: {
    grouppedData: {
      handler(val) {
        if (val) {
          this.preparePdf()
        }
      }
    },
    chartImage: {
      handler(val) {
        if (val) {
          this.preparePdf()
        }
      }
    }
  },
  mounted() {
    this.dcoDataSummary()
  },
  methods: {
    dcoDataSummary() {
      var _this = this
      var bodyData = {}
      var headerData = [
        {
          type: 'string',
          text: 'Asset Id',
          value: 'Asset Id'
        }
      ]

      var _this = this
      // get asset list
      this.grouppedAssets = [
        ...new Set(this.reportData.report?.map((x) => x.SensorName))
      ]
      this.assets = [
        ...new Set(this.reportData.report?.map((x) => x.SensorType))
      ]

      this.assetsProperties = this.assets?.map(function (x) {
        return {
          name: x.replace('Uspace', 'U-Space'),
          children: [
            { Total: `${x}_Total` },
            { Used: `${x}_Used` },
            { Available: `${x}_Available` },
            { Utilization: `${x}_Utilization` }
          ]
        }
      })

      for (var group of this.grouppedAssets) {
        // get report data
        var reportData = this.reportData.report?.find(
          (x) => x.SensorName === group
        )

        // get report historical
        bodyData[group] = reportData.HistoricalDCOValue?.map(function (x) {
          var data = {
            date: _this.formattedDate(x.Timestamp),
            formulaGroup: group,
            unit: x.Unit
          }

          for (var asset of _this.assets) {
            var findAsset = _this.reportData.report?.find(
              (y) => y.SensorType === asset && y.SensorName === group
            )

            // default historical assset value
            data[`${asset}_Total`] = 0
            data[`${asset}_Used`] = 0
            data[`${asset}_Available`] = 0
            data[`${asset}_Utilization`] = 0

            if (findAsset) {
              var assetHistoryValue = findAsset.HistoricalDCOValue?.find(
                (y) => _this.formattedDate(y.Timestamp) === data.date
              )
              data[`${asset}_Total`] = _this.formattedValue(
                assetHistoryValue.Total
              )
              data[`${asset}_Used`] = _this.formattedValue(
                assetHistoryValue.Used
              )
              data[`${asset}_Available`] = _this.formattedValue(
                assetHistoryValue.Available
              )
              data[`${asset}_Utilization`] = _this.formattedValue(
                assetHistoryValue.PercentUtilization
              )
            }
          }
          return data
        })
      }
      this.grouppedData = bodyData
    },
    getReportHeader() {
      return [`Total`, `Used`, `Available`]
    },
    getChartData(formulaGroup) {
      // set groupName of formulaData to sensorName, avoid miss reference group name
      for (let i = 0; i < this.reportData.report.length; i++) {
        this.reportData.report[
          i
        ].FormulaData.GroupName = this.reportData.report[i].SensorName
      }
      // if (formulaGroup === 'MBSB Bank') formulaGroup = 'MBSB'
      // if (formulaGroup === 'Pan Malaysian Pools') formulaGroup = 'PMP'

      var reportData2 = this.reportData.report?.filter(
        (x) => x?.FormulaData?.GroupName === formulaGroup
      )

      let arrayOfChartData = []

      reportData2.forEach((reportData) => {
        let chartData = []
        try {
          for (var dataset of this.getReportHeader()) {
            var newDataset = {
              FormulaData: {},
              HistoricalValue: []
            }

            newDataset['FormulaData'] = JSON.parse(
              JSON.stringify(reportData.FormulaData)
            )
            newDataset['FormulaData'].GroupName = dataset
            newDataset['HistoricalValue'] = reportData.HistoricalDCOValue?.map(
              (x) => {
                return {
                  Timestamp: this.formattedDate(x.Timestamp),
                  DecimalVal:
                    dataset === 'Timestamp' || dataset === 'TOTAL'
                      ? x[dataset]
                      : x[dataset]
                }
              }
            )
            chartData.push(newDataset)
          }
        } catch (err) {
          console.log(err)
        }

        arrayOfChartData.push(chartData)
      })

      return arrayOfChartData
    },
    setChartBaseSource(value, group) {
      if (value) {
        var existingChartImage = this.chartImage?.find((x) => x.name === group)
        if (existingChartImage) {
          existingChartImage.source = value
        } else {
          this.chartImage.push({
            name: group,
            source: value
          })
        }
      }
    },
    preparePdf() {
      try {
        var _this = this

        PdfReportTemplate.clear()
        // set pdf title
        PdfReportTemplate.setTitle(
          `${this.period} ${this.reportData.form.reportType}`
        )

        // cover page
        PdfReportTemplate.addCover(_this.customerLogo)
        for (var header of this.reportHeader) {
          PdfReportTemplate.append({
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: 80,
                style: ['coverTitle'],
                text: header.name,
                alignment: 'left'
              },
              {
                width: '*',
                text: `: ${header.content}`,
                style: ['coverTitleVal'],
                alignment: 'left'
              }
            ],
            margin: [0, 10]
          })
        }

        // toc page
        PdfReportTemplate.newPage()
        PdfReportTemplate.addTOC()

        // report content
        Object.keys(this.grouppedData).forEach(function (index) {
          // set orientation
          PdfReportTemplate.setOrientation('landscape')

          var summaryHeader = [_this.dateColumnLabel()].concat(
            _this.getReportHeader()
          )
          var summaryBody = _this.grouppedData[index]?.map(function (x) {
            x.Date = _this.formattedDate(x.date)
            return x
          })

          let summaryHeaderCustom = [
            [
              {},
              { text: 'Port', colSpan: 4, alignment: 'center' },
              {},
              {},
              {},
              { text: 'Rack', colSpan: 4, alignment: 'center' },
              {},
              {},
              {},
              { text: 'Uspace', colSpan: 4, alignment: 'center' },
              {},
              {},
              {}
            ],
            [
              { text: _this.dateColumnLabel(), alignment: 'center' },
              { text: 'Total', alignment: 'center' },
              { text: 'Used', alignment: 'center' },
              { text: 'Available', alignment: 'center' },
              { text: 'Utilization', alignment: 'center' },
              { text: 'Total', alignment: 'center' },
              { text: 'Used', alignment: 'center' },
              { text: 'Available', alignment: 'center' },
              { text: 'Utilization', alignment: 'center' },
              { text: 'Total', alignment: 'center' },
              { text: 'Used', alignment: 'center' },
              { text: 'Available', alignment: 'center' },
              { text: 'Utilization', alignment: 'center' }
            ]
          ]

          let summaryBodyCustom = []
          summaryBody.forEach((item) => {
            summaryBodyCustom.push([
              { text: _this.readableFormattedDate(item.Date) },
              { text: item['Ports_Total'], alignment: 'right' },
              { text: item['Ports_Used'], alignment: 'right' },
              { text: item['Ports_Available'], alignment: 'right' },
              { text: item['Ports_Utilization'], alignment: 'right' },
              { text: item['Rack_Total'], alignment: 'right' },
              { text: item['Rack_Used'], alignment: 'right' },
              { text: item['Rack_Available'], alignment: 'right' },
              { text: item['Rack_Utilization'], alignment: 'right' },
              { text: item['Uspace_Total'], alignment: 'right' },
              { text: item['Uspace_Used'], alignment: 'right' },
              { text: item['Uspace_Available'], alignment: 'right' },
              { text: item['Uspace_Utilization'], alignment: 'right' }
            ])
          })

          // header
          PdfReportTemplate.addHeader(index)

          // daily details
          const chartImages = _this.chartImage?.filter((x) =>
            x.name.includes(index)
          )
          chartImages.forEach((chartImage) => {
            PdfReportTemplate.addSubHeader(`Chart of ${chartImage.name}`)
            PdfReportTemplate.append({
              image: chartImage ? chartImage?.source[0] : '',
              width: 500,
              margin: [0, 0, 0, 10],
              alignment: 'center'
            })
            PdfReportTemplate.newPage()
          })

          PdfReportTemplate.addSubHeader('Summary Data')
          PdfReportTemplate.append(
            PdfReportTemplate.tableCustom(
              summaryBodyCustom,
              summaryHeaderCustom
            )
          )
        })

        this.$emit('pdfSource', {
          filename: this.getGeneratedFileName(),
          source: PdfReportTemplate.template
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
